// Password must be at least 8 characters and must contain at least one letter and one number
export const checkPassword = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/g;
export const checkRePassword = (password: string) => new RegExp(`^(${password})$`, 'g');
